var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInformation = function SvgInformation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.4998 8C13.4998 7.17157 12.8282 6.5 11.9998 6.5C11.1714 6.5 10.4998 7.17157 10.4998 8C10.4998 8.82843 11.1714 9.5 11.9998 9.5C12.8282 9.5 13.4998 8.82843 13.4998 8ZM13.25 11C13.25 10.7239 13.0261 10.5 12.75 10.5H11.25C10.9739 10.5 10.75 10.7239 10.75 11V17.5C10.75 17.7761 10.9739 18 11.25 18H12.75C13.0261 18 13.25 17.7761 13.25 17.5V11Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInformation);
export default ForwardRef;